<mat-form-field fxFlexFill appearance="outline">
    <mat-label>{{placeholder}}</mat-label>
    <input type="text" placeholder="{{placeholder}}" aria-label="User" matInput [formControl]="searchTerm" [matAutocomplete]="auto" [required]="required">
    <span *ngIf="selectedUser" matSuffix>
        <!-- <syn-source class="syn-source__small" [source]="selectedCompany.source"></syn-source> -->
    </span>
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <mat-option [value]="" (onSelectionChange)="onSelectionChange($event)">Aucune</mat-option>
    <mat-option *ngFor="let user of filteredUsers | async" [value]="user" (onSelectionChange)="onSelectionChange($event, user)">
        <h4 mat-line>{{ displayFn(user) }}</h4>
        <p mat-line> {{ user.email }} </p>
    </mat-option>
</mat-autocomplete>
